export default "__VITE_ASSET__nDJuPEvR__"